import moment from "moment";
import { useTranslation } from "react-i18next";
import { TableCell } from "../../../components/table/table-cell/table-cell";
import InfinityTable from "../../../components/infinity-table/infinity-table";
import UserActivityStatus from "../../../components/user-activity-status/user-activity-status";

const SiteTable = ({ data, sort, onTableChange, onHandleRowClick, isLoading, hasMore, fetchData }) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("site_management.table.name"),
      dataIndex: "name",
      key: "name",
      width: "40%",
      sorter: true,
      sortOrder:
        sort?.field === "name"
          ? (sort?.order === "ASC" ? "ascend" : "descend")
          : null,
      render: (_, site) => <TableCell title={site.name} />,
    },
    {
      title: t("site_management.table.subjects"),
      dataIndex: "subjects",
      key: "subjects",
      width: "15%",
      sorter: true,
      sortOrder:
        sort?.field === "subjectCount"
          ? (sort?.order === "ASC" ? "ascend" : "descend")
          : null,
      render: (_, site) => <TableCell text={site.Subjects?.length ?? 0} />,
    },
    {
      title: t("task_management.table.status"),
      dataIndex: "status",
      key: "status",
      width: "15%",
      sorter: true,
      sortOrder:
        sort?.field === "status"
          ? (sort?.order === "ASC" ? "ascend" : "descend")
          : null,
      render: (_, item) => <UserActivityStatus userStatus={item?.status} />,
    },
    {
      title: t("site_management.table.last_modified"),
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: "30%",
      sorter: true,
      sortOrder:
        sort?.field === "updatedAt"
          ? (sort?.order === "ASC" ? "ascend" : "descend")
          : null,
      render: (_, site) => (
        <TableCell
          text={`${moment(site.updatedAt).utc().format("DD MMM YYYY, HH:mm")}, UTC` || "N/A"}
        />
      ),
    },
  ];

  return (
    <InfinityTable
      data={data}
      tableColumns={columns}
      isLoading={isLoading}
      hasMore={hasMore}
      fetchData={fetchData}
      onHandleRowClick={onHandleRowClick}
      onChange={onTableChange}
    />
  );
};

export default SiteTable;
